// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  height: 95%;
  border-radius: 15px;
}
.card .imagen {
  display: block;
  margin: auto;
  width: 40% !important;
  border-radius: 10px;
}
.card .centrado {
  display: flex;
  justify-content: center;
}
.card .costo-producto {
  font-size: 23px;
  font-weight: 800;
  color: black;
  margin: auto;
  padding: 10px 0;
}
.card .nombre {
  font-size: 22px;
  font-weight: 900;
  text-align: center;
  margin: 25px;
}
.card .descripcion {
  text-align: center !important;
  color: black;
  font-weight: 600;
  margin: auto;
  font-size: 18px;
}
.card .vigencia {
  font-size: 17px;
  font-weight: 500;
  color: black;
  padding: 20px 0;
  text-align: center;
  margin: -1px 0 0 0;
}
.card .precios-escalonados {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  padding: 8px 12px;
  background: #f7f9fc;
  border-radius: 8px;
  margin: 6px 0;
}
.card .precios-escalonados .precio-rango {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
}
.card .precios-escalonados .precio-rango .rango-cant {
  font-weight: 600;
  color: #555;
}
.card .precios-escalonados .precio-rango .rango-precio {
  font-weight: 800;
  color: #111;
}

.container {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.boton-agregar {
  width: 100%;
  font-size: 15px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-product-card/custom-product-card.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AACJ;AAAI;EACI,cAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAER;AAEI;EACI,aAAA;EACA,uBAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AADR;AAII;EACI,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAFR;AAKI;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AAHN;AAMI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAJN;AAMM;EACE,aAAA;EACA,8BAAA;EACA,eAAA;AAJR;AAMQ;EACE,gBAAA;EACA,WAAA;AAJV;AAOQ;EACE,gBAAA;EACA,WAAA;AALV;;AAWA;EACI,aAAA;EACA,8BAAA;EACA,sBAAA;AARJ;;AAWA;EACI,WAAA;EACA,eAAA;EACA,gBAAA;AARJ","sourcesContent":[".card{\n    padding: .5rem;\n    display: flex;\n    justify-content: space-between;\n    height: 95%;\n    border-radius: 15px;\n    .imagen{\n        display: block;\n        margin: auto;\n        width: 40% !important;\n        border-radius: 10px;\n        // overflow: hidden;\n    }\n\n    .centrado{\n        display: flex;\n        justify-content: center;\n    }\n    .costo-producto{\n        font-size: 23px;\n        font-weight: 800;\n        color: black;\n        margin:  auto;\n        padding: 10px 0;\n    }\n\n    .nombre{\n        font-size: 22px;\n        font-weight: 900;\n        text-align: center;\n        margin: 25px;\n    }\n\n    .descripcion{\n        text-align: center !important;\n        color: black;\n        font-weight: 600;\n        margin: auto;\n        font-size: 18px;\n    }\n\n    .vigencia{\n      font-size: 17px;\n      font-weight: 500;\n      color: black;\n      padding: 20px 0;\n      text-align: center;\n      margin: -1px 0 0 0;\n    }\n\n    .precios-escalonados {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n      width: 100%;\n      padding: 8px 12px;\n      background: #f7f9fc;\n      border-radius: 8px;\n      margin: 6px 0;\n\n      .precio-rango {\n        display: flex;\n        justify-content: space-between;\n        font-size: 14px;\n\n        .rango-cant {\n          font-weight: 600;\n          color: #555;\n        }\n\n        .rango-precio {\n          font-weight: 800;\n          color: #111;\n        }\n      }\n    }\n}\n\n.container{\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n}\n\n.boton-agregar{\n    width: 100%;\n    font-size: 15px;\n    font-weight:700;\n    //  margin: -15px 0 0 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
